/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceListExamPreparationApiDto } from './price-list-exam-preparation.model';
import { PriceListPathwayFeeApiDto } from './price-list-pathway-fee.model';
import { PriceListCourseStartDateApiDto } from './price-list-course-start-date.model';
import { PriceListAdditionalInfoApiDto } from './price-list-additional-info.model';
import { PriceListItemApiDto } from './price-list-item.model';
import { PriceListPrivateLessonApiDto } from './price-list-private-lesson.model';
import { PriceListAccommodationApiDto } from './price-list-accommodation.model';
import { PriceListGeneralFeeProductApiDto } from './price-list-general-fee-product.model';
import { PriceListNoteApiDto } from './price-list-note.model';
import { PriceListPathwayProgramApiDto } from './price-list-pathway-program.model';
import { PriceListTransferFeeApiDto } from './price-list-transfer-fee.model';
import { PriceListStudentPreparationApiDto } from './price-list-student-preparation.model';
import { PriceListCourseApiDto } from './price-list-course.model';
import { CodeAndNameApiDto } from './code-and-name.model';

export interface PriceListSchoolApiDto {
  /**
   * Custom element weigh. This property is used to define a custom sort order of this element.
   */
  weight?: number;
  company?: PriceListSchoolApiDto.CompanyEnum;
  isPlus30?: boolean;
  country?: CodeAndNameApiDto;
  currency?: CodeAndNameApiDto;
  pricelist?: string;
  year?: string;
  courses?: Array<PriceListCourseApiDto>;
  courseNotes?: Array<PriceListNoteApiDto>;
  accommodations?: PriceListAccommodationApiDto;
  transfers?: PriceListTransferFeeApiDto;
  generals?: Array<PriceListGeneralFeeProductApiDto>;
  area?: PriceListSchoolApiDto.AreaEnum;
  courseStartDates?: Array<PriceListCourseStartDateApiDto>;
  studentPreparations?: Array<PriceListStudentPreparationApiDto>;
  addOns?: Array<PriceListItemApiDto>;
  accommodationSupplements?: Array<PriceListItemApiDto>;
  seasonSupplements?: Array<PriceListItemApiDto>;
  workExperience?: Array<string>;
  volunteering?: Array<string>;
  privateLessons?: Array<PriceListPrivateLessonApiDto>;
  pathwayPrograms?: Array<PriceListPathwayProgramApiDto>;
  pathwayFees?: Array<PriceListPathwayFeeApiDto>;
  examPreparations?: PriceListExamPreparationApiDto;
  additionalInfo?: Array<PriceListAdditionalInfoApiDto>;
  code?: string;
  name?: string;
}
export namespace PriceListSchoolApiDto {
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
  export const AreaEnum = {
    EU: 'EU',
    ROW: 'ROW',
    ONLINE: 'ONLINE',
  } as const;
  export type AreaEnum = (typeof AreaEnum)[keyof typeof AreaEnum];
}
